import React from 'react'
import { X } from 'lucide-react'
import KycOnboardingWizard from './KycOnboardingWizard'

/**
 * Modal wrapper for employee KYC onboarding (same steps as patron Profile Onboarding).
 */
export default function EmployeeKycWizardModal({
  open,
  onClose,
  staffId,
  employeeName = '',
  employeeId = '',
  onComplete,
}) {
  if (!open || !staffId) return null

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/50 p-4 sm:p-6">
      <div
        className="relative my-4 w-full max-w-5xl rounded-xl bg-white shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="employee-kyc-wizard-title"
      >
        <div className="max-h-[90vh] overflow-y-auto p-4 sm:p-6">
          <KycOnboardingWizard
            variant="staff"
            staffId={String(staffId)}
            employeeName={employeeName}
            employeeId={employeeId}
            embedded
            onClose={onClose}
            onComplete={onComplete}
          />
        </div>
      </div>
      <button
        type="button"
        className="fixed top-4 right-4 rounded-full bg-white/90 p-2 text-gray-700 shadow hover:bg-white sm:hidden"
        onClick={onClose}
        aria-label="Close"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  )
}
